<script>
  import { onMount } from 'svelte';
  import { Link } from 'svelte-routing';
  import { getApiUrl } from "../api";
  import { authFetch} from "../authService";

  let classes = [];
  let isLoading = true;

  onMount(async () => {
    const response = await authFetch(getApiUrl("/memberships"));
    classes = await response.json();
    isLoading = false;
  });
</script>

<div>
  <h2>Choose a Membership Plan</h2>
  {#if isLoading}
    <p>Loading plans...</p>
  {:else}
    <div class="plans-container">
      {#each classes as plan}
        <div class="plan-card">
          <h3>{plan.name}</h3>
          <p class="description">{plan.description}</p>
          <p class="price">${plan.billingAmount.toFixed(2)}</p>
          <p class="frequency">per {plan.billingFrequency}</p>
          <Link to={`/payment/${plan.id}`} class="subscribe-button">Subscribe</Link>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .plans-container { display: flex; justify-content: center; gap: 30px; margin-top: 2rem; }
  .plan-card { border: 1px solid #ddd; border-radius: 8px; padding: 2rem; text-align: center; width: 300px; }
  .price { font-size: 2.5rem; font-weight: bold; margin: 0; }
  .frequency { color: #666; margin-top: 0; }
  .subscribe-button { display: inline-block; margin-top: 1.5rem; padding: 0.8rem 2rem; background-color: #007bff; color: white; text-decoration: none; border-radius: 5px; }
</style>
